<template>

  <!-- Table Container Card -->
  <b-card
    no-body
  >

    <b-overlay
      :show="loading"
      rounded="sm"
      :variant="$store.state.appConfig.layout.skin === 'dark' ? 'dark' : 'light'"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Items</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block ml-50 mr-1"
            />
            <b-button
              variant="primary"
              class="d-inline-block ml-auto ml-md-0"
              @click="dialog = true"
            >
              Nuevo
            </b-button>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Buscar..."
              />
              <b-button
                variant="outline-primary"
                class="ml-2"
                @click="dialogExport = true"
              >
                Exportar
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-modal
        v-model="dialog"
        title="Datos de Alerta"
        hide-footer
      >
        <add-edit
          :item.sync="editedItem"
          :loading.sync="loading"
          :sites.sync="sites"
          :devices.sync="devices"
          :iot-data.sync="iotData"
          :loading-device.sync="loadingDevice"
          :loading-device-iot.sync="loadingDevice"
          @close="close"
          @save="save"
          @get-devices-by-site="getDevicesBySite"
          @get-iot-data-by-device="getIotDataByDevice"
        />
      </b-modal>

      <b-modal
        v-model="dialogDelete"
        title="Eliminar Alerta"
        hide-footer
      >
        <delete-data
          :id-item="editedItem.id"
          :loading.sync="loading"
          @close="close"
          @delete="remove"
        />
      </b-modal>

      <b-modal
        v-model="dialogExport"
        title="Exportar datos"
        hide-footer
      >
        <export-data
          :loading.sync="loading"
          @close="close"
          @export="exportData"
        />
      </b-modal>

      <b-table
        ref="refDataTable"
        :items="fetchData"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No hay datos disponibles."
        :sort-desc.sync="isSortDirDesc"
        class="position-relative"
        :loading="loading"
        loading-text="Cargando..."
      >

        <!-- Column: Name -->
        <template #cell(name)="data">
          <b-link
            class="font-weight-bold"
            @click="editItem(data.item)"
          >
            {{ data.value }}
          </b-link>
        </template>

        <!-- Column: Date Start -->
        <template #cell(dateStart)="data">
          {{ $moment(data.value.split('T')[0]).format('DD/MM/YYYY') }}
        </template>

        <!-- Column: Date End -->
        <template #cell(dateEnd)="data">
          {{ $moment(data.value.split('T')[0]).format('DD/MM/YYYY') }}
        </template>

        <!-- Column: Threshold-->
        <template #cell(threshold)="data">
          <span class="text-capitalize">{{ getKeyName(data.item.key, data.item.threshold_string != '' ? data.item.threshold_string: data.item.threshold, data.item.alertType, data.item.device.deviceData) }} <strong>{{ data.item.operator }} {{ data.value }}</strong></span>
        </template>

        <!-- Column: Enabled -->
        <template #cell(enabled)="data">
          <div class="d-flex align-items-center justify-content-center">
            <b-form-checkbox
              :id="`alert-row-${data.item.id}-enabled-checkbox`"
              :checked="data.item.enabled"
              disabled
              class="m-0"
            />
            <b-tooltip
              title="Habilitado"
              class="cursor-pointer"
              :target="`alert-row-${data.item.id}-enabled-checkbox`"
            />
          </div>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <div class="d-flex align-items-center justify-content-center text-nowrap">
            <feather-icon
              :id="`alert-config-row-${data.item.id}-edit-icon`"
              icon="EditIcon"
              class="cursor-pointer mr-1"
              size="16"
              @click="editItem(data.item)"
            />
            <b-tooltip
              title="Editar"
              class="cursor-pointer"
              :target="`alert-config-row-${data.item.id}-edit-icon`"
            />

            <feather-icon
              :id="`alert-config-row-${data.item.id}-trash-icon`"
              icon="TrashIcon"
              class="cursor-pointer"
              size="16"
              @click="deleteItem(data.item)"
            />
            <b-tooltip
              title="Eliminar"
              class="cursor-pointer"
              :target="`alert-config-row-${data.item.id}-trash-icon`"
            />
          </div>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Mostrando {{ dataMeta.from }} a {{ dataMeta.to }} de {{ dataMeta.of }} items</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalData"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>

      <template #overlay>
        <!-- Show loading spinner if loading -->
        <loading-logo
          v-if="loading"
          class="mt-4 mb-4"
        />
      </template>
    </b-overlay>
  </b-card>

</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable,
  BPagination, BTooltip, BOverlay, BFormCheckbox, BLink,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { onUnmounted } from '@vue/composition-api'
import store from '@/store'
import DeleteData from '@/views/utils/DeleteData.vue'
import ExportData from '@/views/utils/ExportData.vue'
import exportFromJSON from 'export-from-json'
import AddEdit from './AddEdit.vue'
import alertConfigStoreModule from './alertConfigStoreModule'
import allFetchData from './allFetchData'
import LoadingLogo from '../../miscellaneous/LoadingLogo.vue'
import orgStoreModule from '../../organizations/orgStoreModule'
import orgFetchData from '../../organizations/allFetchData'
import deviceStoreModule from '../../devices/deviceStoreModule'
import deviceFetchData from '../../devices/allFetchData'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BPagination,
    BTooltip,
    vSelect,
    AddEdit,
    DeleteData,
    ExportData,
    LoadingLogo,
    BOverlay,
    BFormCheckbox,
    BLink,
  },
  setup() {
    const ALERT_CONFIG_APP_STORE_MODULE_NAME = 'alertConf'
    const ORGANIZATION_APP_STORE_MODULE_NAME = 'org'
    const DEVICE_APP_STORE_MODULE_NAME = 'devices'

    // Register module
    if (!store.hasModule(ALERT_CONFIG_APP_STORE_MODULE_NAME)) store.registerModule(ALERT_CONFIG_APP_STORE_MODULE_NAME, alertConfigStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(ALERT_CONFIG_APP_STORE_MODULE_NAME)) store.unregisterModule(ALERT_CONFIG_APP_STORE_MODULE_NAME)
    })

    // Register module Org
    if (!store.hasModule(ORGANIZATION_APP_STORE_MODULE_NAME)) store.registerModule(ORGANIZATION_APP_STORE_MODULE_NAME, orgStoreModule)

    // UnRegister on leave Org
    onUnmounted(() => {
      if (store.hasModule(ORGANIZATION_APP_STORE_MODULE_NAME)) store.unregisterModule(ORGANIZATION_APP_STORE_MODULE_NAME)
    })

    // Register module Devices
    if (!store.hasModule(DEVICE_APP_STORE_MODULE_NAME)) store.registerModule(DEVICE_APP_STORE_MODULE_NAME, deviceStoreModule)

    // UnRegister on leave Devices
    onUnmounted(() => {
      if (store.hasModule(DEVICE_APP_STORE_MODULE_NAME)) store.unregisterModule(DEVICE_APP_STORE_MODULE_NAME)
    })

    const {
      fetchData,
      fetchAdd,
      fetchUpdate,
      fetchDelete,
      fetchExport,
      tableColumns,
      perPage,
      currentPage,
      totalData,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refDataTable,
      loading,
      statusFilter,
      refetchData,
    } = allFetchData()

    // sites
    const {
      fetchData: fetchSites,
      loading: loadingSites,
    } = orgFetchData()

    // devices
    const {
      fetchDevicesBySite: fetchDevicesBySites,
      fetchGetLastIoTDataByCloudId: fetchDeviceIotData,
      loading: loadingDevice,
    } = deviceFetchData()

    return {
      fetchData,
      fetchAdd,
      fetchUpdate,
      fetchDelete,
      fetchExport,
      tableColumns,
      perPage,
      currentPage,
      totalData,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refDataTable,
      loading,
      statusFilter,
      refetchData,
      fetchSites,
      loadingSites,
      fetchDevicesBySites,
      loadingDevice,
      fetchDeviceIotData,
    }
  },
  data() {
    return {
      dialog: false,
      dialogDelete: false,
      dialogExport: false,
      editedIndex: -1,
      editedItem: {
        id: null,
        name: '',
        deviceId: '',
        threshold: '',
        operator: '',
        enabled: true,
        site: '',
        devices: [],
        user: '',
        key: null,
        threshold_string: null,
        alertType: 'alert',
      },
      defaultItem: {
        id: null,
        name: '',
        deviceId: '',
        threshold: '',
        operator: '',
        enabled: true,
        site: '',
        devices: [],
        key: null,
        threshold_string: null,
        alertType: 'alert',
      },
      sites: [],
      devices: [],
      iotData: [],
      optionsOperator: [
        { value: '>', text: 'mayor a' },
        { value: '<', text: 'menor a' },
        { value: '>=', text: 'mayor igual a' },
        { value: '<=', text: 'menor igual a' },
        { value: '==', text: 'igual a' },
        { value: '!=', text: 'diferente a' },
      ],
    }
  },
  watch: {
    dialog(val) {
      // eslint-disable-next-line no-unused-expressions
      val || this.close()
    },
  },
  mounted() {
    this.fetchSites('', res => { this.sites = res })
  },
  methods: {
    add() {
      this.fetchAdd(this.editedItem, () => {
        this.close()
      })
    },
    edit() {
      this.fetchUpdate(this.editedItem, () => {
        this.close()
      })
    },
    remove() {
      this.fetchDelete(this.editedItem.id, () => {
        this.close()
      })
    },
    editItem(item) {
      this.editedItem = { ...item }
      this.editedItem.site = item.device.site.id
      this.devices = [item.device]
      this.editedItem.deviceId = item.deviceId
      this.dialog = true
    },
    deleteItem(item) {
      this.editedItem = { ...item }
      this.dialogDelete = true
    },
    save() {
      const userData = JSON.parse(localStorage.getItem('userData'))
      this.editedItem.user = userData?.name || userData?.fullName  
      console.log(this.editedItem);
      if (this.editedItem.id > 0) {
        this.edit()
      } else {
        this.add()
      }
    },
    close() {
      this.dialog = false
      this.dialogExport = false
      this.dialogDelete = false
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem }
        this.editedIndex = -1
      })
    },
    exportData() {
      this.fetchExport(this.editedItem, res => {
        try {
          const fileName = 'Listado Configuraciones de Alertas'
          const exportType = exportFromJSON.types.xls
          const data = res.map(item => ({
            alerta: item.name,
            ubicacion: item.device.site.name,
            dispositivo: item.device.name,
            fecha: item.createdAt,
            operador: item.operator ? this.optionsOperator.filter(op => op.value === item.operator)[0].text : 'igual a',
            umbral: item.threshold ? item.threshold : item.threshold_string,
            habilitado: item.enabled ? 'Si' : 'No',
          }))
          if (data) exportFromJSON({ data, fileName, exportType })
        } catch (error) {
          console.log('error', error)
        }
        this.close()
      })
    },
    getDevicesBySite() {
      this.fetchDevicesBySites(this.editedItem.site, res => {
        // add item all index 0
        this.devices = res
      })
    },
    getIotDataByDevice(cloudId) {
      const iotDataKeys = []
      this.fetchDeviceIotData(cloudId, res => {
        Object.keys(res.data).forEach(key => {
          iotDataKeys.push(key)
        })
        this.iotData = iotDataKeys
      })
    },
    getKeyName(alertKey, value, alertType, deviceData) {
      if(!deviceData){
        const device = this.devices.find(device => device.id === this.editedItem.deviceId)
        if(device){
          deviceData = device.deviceData
        }
      }      
      if (alertKey && alertType === 'boolean' && deviceData.sensorType === 'boolean') {
        const foundData = deviceData.find(data => (Array.isArray(data.data) && data.data.includes(alertKey))
          || (!Array.isArray(data.data) && data.data === alertKey),
        );
        if (foundData) {
          const textFound = (foundData.offValue === value) ? foundData.offText : foundData.onText
          return textFound
        }
      }
      if (alertKey && alertType === 'number') {
        const foundData = deviceData.find(data => (Array.isArray(data.data) && data.data.includes(alertKey))
          || (!Array.isArray(data.data) && data.data === alertKey),
        );
        return foundData.name
      }
      if (alertKey && alertType === 'boolean' && Array.isArray(deviceData)) {        
        const matchingDevice = deviceData.find(device => device.sensorType === 'list');

        if (matchingDevice) {
          const matchingItem = matchingDevice.list?.list.find(item => item.key === value);

          if (matchingItem) {
            return matchingItem.text;
          }
        } 
      }

      return value
    },
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.status-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
</style>
